module.exports = __webpack_public_path__ + "h5/img/open.9bdfbd3e.gif";